import React, { useEffect } from 'react';
import { Button } from 'reactstrap';
import AUX from '../../../../hoc/Aux_';
import { CircularProgressbar } from 'react-circular-progressbar';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import {
  deleteScreenshot,
  getScreenshotDeatil,
} from '../../../../redux/MainAction';
import Swal from 'sweetalert2';

const ImagesModal = ({ open, onClose, ID }) => {
  const dispatch = useDispatch();
  const list = useSelector((state) => state.Webtracker.screenShotDetails);

  const percentage = 0;

  console.log(ID);

  useEffect(() => {
    if (ID?.employeeId) getListItem();
  }, [ID?.employeeId]);

  const getListItem = () => {
    var pay = {
      projectTaskActivityScreenshotId: ID?.id,
      employeeId: ID?.employeeId,
    };
    dispatch(getScreenshotDeatil(pay));
  };

  const onDeleteHandle = (id) => {
    if (id) {
      Swal.fire({
        title: 'Are you sure ?',
        text: 'You will not be able to recover this !!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it',
      }).then((Confirm) => {
        if (Confirm.isConfirmed) {
          var data = {
            projectTaskActivityScreenshotId: id,
          };
          dispatch(deleteScreenshot(data));
        }
      });
    }

    //
  };
  const convertSeconds = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remaingSeconds = Math.floor(seconds % 60);
    return `${minutes}m : ${remaingSeconds}s`;
  };

  return (
    <AUX>
      <div className="page-content-wrapper">
        <div className="container-fluid">
          <div className={`overlay ${open ? 'open' : ''}`} id="myNav">
            <div className="overlay-content">
              <ul
                className=" nav nav-tabs nav-tabs-custom  nav-justified"
                role="tablist"
              >
                <li className="nav-item d-flex justify-content-between align-items-center mb-1 px-2">
                  <h5 className="d-none d-md-block">Screenshot</h5>
                  <i
                    className="mdi mdi-close"
                    onClick={onClose}
                    style={{ fontSize: '22px', cursor: 'pointer' }}
                  />
                </li>
                {/* <li className="nav-item">
                <a className="nav-link" data-toggle="tab" href="#activity_details" role="tab">
                    <span className="d-none d-md-block">Activity Details</span><span className="d-block d-md-none"><i className="mdi mdi-email h5"></i></span>
                </a>
            </li>
            <li className="nav-item">
                <a className="nav-link" data-toggle="tab" href="#computer_details" role="tab">
                    <span className="d-none d-md-block">Computer Details</span><span className="d-block d-md-none"><i className="mdi mdi-account h5"></i></span>
                </a>
            </li> */}
              </ul>
              <div className="tab-content">
                <div
                  className="tab-pane active p-3"
                  id="screenshot"
                  role="tabpanel"
                >
                  <div>
                    <div className="slide_Headr mb-2">
                      <span>
                        Project :{' '}
                        <b>
                          {ID?.projectTaskActivity?.projectTask?.project?.name}
                        </b>
                      </span>
                    </div>
                    {/* <div className=''>
                        
                    </div> */}
                    <div
                      className="d-flex justify-content-start align-items-center"
                      style={{ gap: '20px', height: '70px' }}
                    >
                      {/* <div
                        className="d-flex justify-content-center align-items-center"
                        style={{
                          width: 60,
                          height: 60,
                          borderRight: '1px solid #E4E0E1',
                          padding: '0 10px',
                        }}
                      >
                        <CircularProgressbar
                          value={ID?.activitySummary?.completionPercent}
                          text={`${list?.data?.activitySummary?.completionPercent}%`}
                        />
                      </div> */}
                      <div
                        className="d-flex justify-content-center align-items-center"
                        style={{
                          borderRight: '1px solid #E4E0E1',
                          padding: '0 12px',
                        }}
                      >
                        <span className="text-center font-14">
                          Mouse <br />
                          {list?.data?.activitySummary?.mouseClick}
                        </span>
                      </div>
                      <div
                        className="d-flex justify-content-center align-items-center"
                        style={{
                          borderRight: '1px solid #E4E0E1',
                          padding: '0 12px',
                        }}
                      >
                        <span className="text-center  font-14">
                          Keyboard <br />{' '}
                          {list?.data?.activitySummary?.keystroke}
                        </span>
                      </div>
                      {/* <div
                        className="d-flex justify-content-center align-items-center"
                        style={{
                          borderRight: '1px solid #E4E0E1',
                          padding: '0 12px',
                        }}
                      >
                        <span className="text-center font-14">
                          Scroll <br /> {list?.data?.activitySummary?.scroll}
                        </span>
                      </div> */}
                      <div
                        className="d-flex justify-content-center align-items-center"
                        style={{
                          borderRight: '1px solid #E4E0E1',
                          padding: '0 12px',
                        }}
                      >
                        <span className="text-center font-14">
                          AVG Actions per/min <br />{' '}
                          {list?.data?.activitySummary?.averageActionPerMinute?.toFixed(
                            2
                          )}
                        </span>
                      </div>
                      <div
                        className="d-flex justify-content-center align-items-center"
                        style={{
                          borderRight: '1px solid #E4E0E1',
                          padding: '0 12px',
                        }}
                      >
                        <span className="text-center font-14">
                          Minutes
                          <br />{' '}
                          <span style={{ whiteSpace: 'nowrap' }}>
                            {convertSeconds(
                              list?.data?.activitySummary?.totalTime
                            )}
                          </span>
                        </span>
                      </div>
                    </div>
                    <div>
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="font-14 text-muted">
                          <b>Date:</b>{' '}
                          {moment(ID?.media?.createdAt).format(
                            'MMMM Do YYYY, h:mm:ss a'
                          )}
                        </span>
                        <Button
                          onClick={() => onDeleteHandle(ID?.id)}
                          outline
                          color="danger"
                          size="sm"
                          className="d-flex justify-content-center align-items-center"
                        >
                          <i className=" fa fa-trash-o mr-2"></i> Delete
                          Selected Screenshot
                        </Button>
                      </div>
                      <div className="mt-4 screen_image">
                        <img
                          src={ID?.media?.url}
                          alt="no Document"
                          style={{ objectFit: 'contain' }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="tab-pane p-3" id="activity_details" role="tabpanel">
                <div>
                       
                </div>
            </div> */}
                {/* <div className="tab-pane p-3" id="computer_details" role="tabpanel">
                <div>
                       
                       
                </div>
            </div> */}
              </div>

              {/* <Button className='ml-3' onClick={onClose} size='sm'>Close</Button> */}
            </div>
          </div>
        </div>
      </div>
    </AUX>
  );
};

export default ImagesModal;
